import { render, staticRenderFns } from "./AnesthesiaDetail.vue?vue&type=template&id=7e7b4bda&scoped=true"
var script = {}
import style0 from "./AnesthesiaDetail.vue?vue&type=style&index=0&id=7e7b4bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7b4bda",
  null
  
)

export default component.exports